import FailShare from './instance/FailShare.vue'
import FailReceive from './instance/FailReceive.vue'
import FailGetCoupon from './instance/FailGetCoupon.vue'
import SuccessShare from './instance/SuccessShare.vue'
import SuccessReceive from './instance/SuccessReceive.vue'
import ShareWeChat from './instance/ShareWeChat.vue'
import RuleToast from './instance/RuleToast.vue'
import CommonErr from './instance/CommonErr.vue'
import OpenCardErr from './instance/OpenCardErr.vue'

let className = {
  FailShare,
  FailReceive,
  FailGetCoupon,
  SuccessShare,
  RuleToast,
  SuccessReceive,
  ShareWeChat,
  CommonErr,
  OpenCardErr
}
// import FailShare from './instance/FailShare.vue'
const Toast = {}
const pageScroll = (() => {
  const fn = e => {
    let evt = e || window.event
    evt.preventDefault()
    evt.stopPropagation()
  }
  let isLock = false

  return {
    lock(el) {
      if (isLock) return
      isLock = true
      ;(el || document).addEventListener('mousewheel', fn, { passive: false })
      ;(el || document).addEventListener('touchmove', fn, { passive: false })
    },
    unlock(el) {
      isLock = false
      ;(el || document).removeEventListener('mousewheel', fn, {
        passive: false
      })
      ;(el || document).removeEventListener('touchmove', fn, { passive: false })
    }
  }
})()
let ToastClass
let toastInstance
Toast.install = Vue => {
  Vue.prototype.$myToast = options => {
    ToastClass = Vue.extend(className[options.class])
    toastInstance = new ToastClass().$mount()
    toastInstance.closeEvent = Vue.closeToast
    toastInstance.event = options.event
    if(options.other) {
      toastInstance.other = options.other
    }
    document.body.appendChild(toastInstance.$el)
    pageScroll.lock()
  }
  Vue.closeToast = () => {
    const el = toastInstance.$el
    el.parentNode && el.parentNode.removeChild(el)

    //恢复滚动
    pageScroll.unlock()
  }
}
export default Toast
